<template>
  <v-text-field
    class="soraban-text-field"
    outline
    :hint="hint"
    :persistent-hint="true"
    :error-count="1"
    :rules="rules"
    :error-messages="errorMessages"
    :disabled="disabled"
    :type="type"
    :label="label"
    :append-icon="appendIcon"
    v-bind="$attrs"
    v-model="valueAlias"
    @blur="$emit('blur')"
    @click="$emit('click')"
    @click:append="$emit('click:append')"
    @focus="$emit('focus')"
    @change="$emit('change', value)"
  >
  </v-text-field>
</template>

<script>
export default {
  name: 'SorabanTextField',
  props: {
    value: {
      required: false,
      type: [String, Number],
      default: '',
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    noMessaging: {
      required: false,
      type: Boolean,
      default: false,
    },
    type: {
      required: false,
      default: 'text',
      type: String,
      validator: p =>
        ['text', 'number', 'email', 'number', 'password', 'tel'].includes(p),
    },
    errorMessage: {
      required: false,
      type: String || null,
      default: null,
    },
    label: {
      required: true,
      default: '',
      type: String,
    },
    appendIcon: {
      required: false,
      type: String,
      default: '',
    },
    hint: {
      required: false,
      default: '',
      type: String,
    },
    mask: {
      // See Mask Legend here: https://vuetifyjs.com/en/components/text-fields#
      required: false,
      default: '',
      type: String,
    },
    rules: {
      required: false,
      type: Array,
      default: () => [],
    },
  },
  computed: {
    errorMessages() {
      return this.errorMessage ? [this.errorMessage] : null;
    },
    valueAlias: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped lang="postcss">
.soraban-text-field >>> {
}
</style>
